/**
 * This file is auto-generated by the generateIconMap script on 2/18/2026.
 */
import { AbTestIcon } from './icons/AbTestIcon';
import { AccessibilityIcon } from './icons/AccessibilityIcon';
import { ActivityIcon } from './icons/ActivityIcon';
import { AddFolderIcon } from './icons/AddFolderIcon';
import { AddLayoutIcon } from './icons/AddLayoutIcon';
import { AddMediaIcon } from './icons/AddMediaIcon';
import { AnnotationLinkIcon } from './icons/AnnotationLinkIcon';
import { AppearanceIcon } from './icons/AppearanceIcon';
import { ArchiveIcon } from './icons/ArchiveIcon';
import { ArrowDownIcon } from './icons/ArrowDownIcon';
import { ArrowLeftIcon } from './icons/ArrowLeftIcon';
import { ArrowRightIcon } from './icons/ArrowRightIcon';
import { ArrowUpIcon } from './icons/ArrowUpIcon';
import { ArrowUpRightIcon } from './icons/ArrowUpRightIcon';
import { AsteriskIcon } from './icons/AsteriskIcon';
import { AudioDescriptionIcon } from './icons/AudioDescriptionIcon';
import { AutoScrollIcon } from './icons/AutoScrollIcon';
import { BackgroundIcon } from './icons/BackgroundIcon';
import { BankIcon } from './icons/BankIcon';
import { BellIcon } from './icons/BellIcon';
import { BoltIcon } from './icons/BoltIcon';
import { BulletListIcon } from './icons/BulletListIcon';
import { CalendarIcon } from './icons/CalendarIcon';
import { CallToActionIcon } from './icons/CallToActionIcon';
import { CameraIcon } from './icons/CameraIcon';
import { CameraOffIcon } from './icons/CameraOffIcon';
import { CaretDownIcon } from './icons/CaretDownIcon';
import { CaretDownStrongIcon } from './icons/CaretDownStrongIcon';
import { CaretLeftIcon } from './icons/CaretLeftIcon';
import { CaretLeftStrongIcon } from './icons/CaretLeftStrongIcon';
import { CaretRightIcon } from './icons/CaretRightIcon';
import { CaretRightStrongIcon } from './icons/CaretRightStrongIcon';
import { CaretUpIcon } from './icons/CaretUpIcon';
import { CaretUpStrongIcon } from './icons/CaretUpStrongIcon';
import { ChannelIcon } from './icons/ChannelIcon';
import { ChaptersIcon } from './icons/ChaptersIcon';
import { CheckmarkIcon } from './icons/CheckmarkIcon';
import { CheckmarkCircleIcon } from './icons/CheckmarkCircleIcon';
import { CheckmarkCircleOutlineIcon } from './icons/CheckmarkCircleOutlineIcon';
import { CheckmarkThreeQuatersCircleIcon } from './icons/CheckmarkThreeQuatersCircleIcon';
import { CircleSlashedIcon } from './icons/CircleSlashedIcon';
import { ClapboardIcon } from './icons/ClapboardIcon';
import { ClipsIcon } from './icons/ClipsIcon';
import { CloseIcon } from './icons/CloseIcon';
import { CloseOctagonIcon } from './icons/CloseOctagonIcon';
import { ClosedCaptionsIcon } from './icons/ClosedCaptionsIcon';
import { CmdIcon } from './icons/CmdIcon';
import { CollapseIcon } from './icons/CollapseIcon';
import { CollapseDiagonalIcon } from './icons/CollapseDiagonalIcon';
import { CollectionIcon } from './icons/CollectionIcon';
import { CommentsIcon } from './icons/CommentsIcon';
import { CompanyIcon } from './icons/CompanyIcon';
import { CompareIcon } from './icons/CompareIcon';
import { ConnectionOkayIcon } from './icons/ConnectionOkayIcon';
import { ConnectionPoorIcon } from './icons/ConnectionPoorIcon';
import { ConnectionStrongIcon } from './icons/ConnectionStrongIcon';
import { ContentLibraryIcon } from './icons/ContentLibraryIcon';
import { ControlsIcon } from './icons/ControlsIcon';
import { CreditCardIcon } from './icons/CreditCardIcon';
import { CreditsIcon } from './icons/CreditsIcon';
import { CursorClickIcon } from './icons/CursorClickIcon';
import { DeleteIcon } from './icons/DeleteIcon';
import { DesktopIcon } from './icons/DesktopIcon';
import { DocsDevIcon } from './icons/DocsDevIcon';
import { DotsHorizontalIcon } from './icons/DotsHorizontalIcon';
import { DownloadIcon } from './icons/DownloadIcon';
import { EditTranscriptIcon } from './icons/EditTranscriptIcon';
import { EllipsesVerticalIcon } from './icons/EllipsesVerticalIcon';
import { EmbedIcon } from './icons/EmbedIcon';
import { EnvelopeIcon } from './icons/EnvelopeIcon';
import { EnvelopeOpenIcon } from './icons/EnvelopeOpenIcon';
import { ErrorIcon } from './icons/ErrorIcon';
import { ExpandIcon } from './icons/ExpandIcon';
import { ExpandDiagonalIcon } from './icons/ExpandDiagonalIcon';
import { ExpandDiagonalWindowIcon } from './icons/ExpandDiagonalWindowIcon';
import { ExpandHorizontalIcon } from './icons/ExpandHorizontalIcon';
import { FastForwardIcon } from './icons/FastForwardIcon';
import { FavoriteIcon } from './icons/FavoriteIcon';
import { FavoriteOutlineIcon } from './icons/FavoriteOutlineIcon';
import { FeaturedIcon } from './icons/FeaturedIcon';
import { FileTreeIcon } from './icons/FileTreeIcon';
import { FillIcon } from './icons/FillIcon';
import { FilmStripIcon } from './icons/FilmStripIcon';
import { FilterIcon } from './icons/FilterIcon';
import { FitIcon } from './icons/FitIcon';
import { FontsIcon } from './icons/FontsIcon';
import { FooterIcon } from './icons/FooterIcon';
import { FullScreenIcon } from './icons/FullScreenIcon';
import { GearIcon } from './icons/GearIcon';
import { GettingStartedIcon } from './icons/GettingStartedIcon';
import { GridIcon } from './icons/GridIcon';
import { GripDotsVerticalIcon } from './icons/GripDotsVerticalIcon';
import { HeaderIcon } from './icons/HeaderIcon';
import { HelpCenterIcon } from './icons/HelpCenterIcon';
import { HideIcon } from './icons/HideIcon';
import { HomeIcon } from './icons/HomeIcon';
import { HourglassIcon } from './icons/HourglassIcon';
import { ImportIcon } from './icons/ImportIcon';
import { InfoIcon } from './icons/InfoIcon';
import { IntegrationsIcon } from './icons/IntegrationsIcon';
import { KeyboardIcon } from './icons/KeyboardIcon';
import { LayoutIcon } from './icons/LayoutIcon';
import { LeaveIcon } from './icons/LeaveIcon';
import { LightBulbIcon } from './icons/LightBulbIcon';
import { LinkIcon } from './icons/LinkIcon';
import { ListIcon } from './icons/ListIcon';
import { LiveIcon } from './icons/LiveIcon';
import { LocalizationIcon } from './icons/LocalizationIcon';
import { LockIcon } from './icons/LockIcon';
import { LogoutIcon } from './icons/LogoutIcon';
import { MaximizeIcon } from './icons/MaximizeIcon';
import { MediaIcon } from './icons/MediaIcon';
import { MegaphoneIcon } from './icons/MegaphoneIcon';
import { MenuIcon } from './icons/MenuIcon';
import { MicIcon } from './icons/MicIcon';
import { MicOffIcon } from './icons/MicOffIcon';
import { MinimizeIcon } from './icons/MinimizeIcon';
import { MinusIcon } from './icons/MinusIcon';
import { MinusCircleIcon } from './icons/MinusCircleIcon';
import { MobileIcon } from './icons/MobileIcon';
import { MoreOptionsIcon } from './icons/MoreOptionsIcon';
import { MoveLeftIcon } from './icons/MoveLeftIcon';
import { MoveRightIcon } from './icons/MoveRightIcon';
import { MusicIcon } from './icons/MusicIcon';
import { MyLibraryIcon } from './icons/MyLibraryIcon';
import { OnAirIcon } from './icons/OnAirIcon';
import { OpenNewIcon } from './icons/OpenNewIcon';
import { OverviewIcon } from './icons/OverviewIcon';
import { PageIcon } from './icons/PageIcon';
import { PanelLeftIcon } from './icons/PanelLeftIcon';
import { PanelRightIcon } from './icons/PanelRightIcon';
import { PanelUpIcon } from './icons/PanelUpIcon';
import { PaperClipIcon } from './icons/PaperClipIcon';
import { PasswordIcon } from './icons/PasswordIcon';
import { PauseIcon } from './icons/PauseIcon';
import { PencilIcon } from './icons/PencilIcon';
import { PencilSparkleIcon } from './icons/PencilSparkleIcon';
import { PeopleIcon } from './icons/PeopleIcon';
import { PinIcon } from './icons/PinIcon';
import { PinSlashIcon } from './icons/PinSlashIcon';
import { PipIcon } from './icons/PipIcon';
import { PlayIcon } from './icons/PlayIcon';
import { PlayerIcon } from './icons/PlayerIcon';
import { PlaylistIcon } from './icons/PlaylistIcon';
import { PlusIcon } from './icons/PlusIcon';
import { PodcastIcon } from './icons/PodcastIcon';
import { PreviewIcon } from './icons/PreviewIcon';
import { PrivateChatIcon } from './icons/PrivateChatIcon';
import { PrivateUserSessionsIcon } from './icons/PrivateUserSessionsIcon';
import { ProjectIcon } from './icons/ProjectIcon';
import { ProjectOpenIcon } from './icons/ProjectOpenIcon';
import { PropertiesIcon } from './icons/PropertiesIcon';
import { QuestionChatIcon } from './icons/QuestionChatIcon';
import { QuestionMarkIcon } from './icons/QuestionMarkIcon';
import { ReactIcon } from './icons/ReactIcon';
import { RecordIcon } from './icons/RecordIcon';
import { RecordGroupIcon } from './icons/RecordGroupIcon';
import { RedoIcon } from './icons/RedoIcon';
import { RefreshIcon } from './icons/RefreshIcon';
import { RemixIcon } from './icons/RemixIcon';
import { ReplaceIcon } from './icons/ReplaceIcon';
import { ReplyIcon } from './icons/ReplyIcon';
import { RequestVideoIcon } from './icons/RequestVideoIcon';
import { RevertToOriginalIcon } from './icons/RevertToOriginalIcon';
import { RewindIcon } from './icons/RewindIcon';
import { SaveIcon } from './icons/SaveIcon';
import { SaveAsCopyIcon } from './icons/SaveAsCopyIcon';
import { ScissorsIcon } from './icons/ScissorsIcon';
import { ScreenshareOffIcon } from './icons/ScreenshareOffIcon';
import { ScreenshareOnIcon } from './icons/ScreenshareOnIcon';
import { SearchIcon } from './icons/SearchIcon';
import { SendIcon } from './icons/SendIcon';
import { ShapesIcon } from './icons/ShapesIcon';
import { ShareIcon } from './icons/ShareIcon';
import { SharingPermissionsIcon } from './icons/SharingPermissionsIcon';
import { SimulcastIcon } from './icons/SimulcastIcon';
import { SortIcon } from './icons/SortIcon';
import { SparkleIcon } from './icons/SparkleIcon';
import { SpeedIcon } from './icons/SpeedIcon';
import { SpinnerIcon } from './icons/SpinnerIcon';
import { StatsIcon } from './icons/StatsIcon';
import { SwitchAccountsIcon } from './icons/SwitchAccountsIcon';
import { TagIcon } from './icons/TagIcon';
import { TeleprompterIcon } from './icons/TeleprompterIcon';
import { TextBoldIcon } from './icons/TextBoldIcon';
import { TextItalicsIcon } from './icons/TextItalicsIcon';
import { TextSizeIcon } from './icons/TextSizeIcon';
import { ThumbnailIcon } from './icons/ThumbnailIcon';
import { ThumbsDownIcon } from './icons/ThumbsDownIcon';
import { ThumbsUpIcon } from './icons/ThumbsUpIcon';
import { TimelineVerticalIcon } from './icons/TimelineVerticalIcon';
import { TokenIcon } from './icons/TokenIcon';
import { TranscriptIcon } from './icons/TranscriptIcon';
import { TransitionsIcon } from './icons/TransitionsIcon';
import { TransparencyIcon } from './icons/TransparencyIcon';
import { TrendsIcon } from './icons/TrendsIcon';
import { TrialUnlockClockIcon } from './icons/TrialUnlockClockIcon';
import { TrimIcon } from './icons/TrimIcon';
import { TurnstileIcon } from './icons/TurnstileIcon';
import { UndoIcon } from './icons/UndoIcon';
import { UnlockIcon } from './icons/UnlockIcon';
import { UploadIcon } from './icons/UploadIcon';
import { UsersPermissionsIcon } from './icons/UsersPermissionsIcon';
import { ViewStreamIcon } from './icons/ViewStreamIcon';
import { VolumeIcon } from './icons/VolumeIcon';
import { VolumeOffIcon } from './icons/VolumeOffIcon';
import { VolumeUpIcon } from './icons/VolumeUpIcon';
import { VolumeXIcon } from './icons/VolumeXIcon';
import { WandIcon } from './icons/WandIcon';
import { WaveformIcon } from './icons/WaveformIcon';
import { WebhookIcon } from './icons/WebhookIcon';
import { WriteIcon } from './icons/WriteIcon';
import { ZoomInIcon } from './icons/ZoomInIcon';
import { ZoomOutIcon } from './icons/ZoomOutIcon';

export const iconMap = {
  'ab-test': AbTestIcon,
  accessibility: AccessibilityIcon,
  activity: ActivityIcon,
  'add-folder': AddFolderIcon,
  'add-layout': AddLayoutIcon,
  'add-media': AddMediaIcon,
  'annotation-link': AnnotationLinkIcon,
  appearance: AppearanceIcon,
  archive: ArchiveIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-up-right': ArrowUpRightIcon,
  asterisk: AsteriskIcon,
  'audio-description': AudioDescriptionIcon,
  'auto-scroll': AutoScrollIcon,
  background: BackgroundIcon,
  bank: BankIcon,
  bell: BellIcon,
  bolt: BoltIcon,
  'bullet-list': BulletListIcon,
  calendar: CalendarIcon,
  'call-to-action': CallToActionIcon,
  camera: CameraIcon,
  'camera-off': CameraOffIcon,
  'caret-down': CaretDownIcon,
  'caret-down-strong': CaretDownStrongIcon,
  'caret-left': CaretLeftIcon,
  'caret-left-strong': CaretLeftStrongIcon,
  'caret-right': CaretRightIcon,
  'caret-right-strong': CaretRightStrongIcon,
  'caret-up': CaretUpIcon,
  'caret-up-strong': CaretUpStrongIcon,
  channel: ChannelIcon,
  chapters: ChaptersIcon,
  checkmark: CheckmarkIcon,
  'checkmark-circle': CheckmarkCircleIcon,
  'checkmark-circle-outline': CheckmarkCircleOutlineIcon,
  'checkmark-three-quaters-circle': CheckmarkThreeQuatersCircleIcon,
  'circle-slashed': CircleSlashedIcon,
  clapboard: ClapboardIcon,
  clips: ClipsIcon,
  close: CloseIcon,
  'close-octagon': CloseOctagonIcon,
  'closed-captions': ClosedCaptionsIcon,
  cmd: CmdIcon,
  collapse: CollapseIcon,
  'collapse-diagonal': CollapseDiagonalIcon,
  collection: CollectionIcon,
  comments: CommentsIcon,
  company: CompanyIcon,
  compare: CompareIcon,
  'connection-okay': ConnectionOkayIcon,
  'connection-poor': ConnectionPoorIcon,
  'connection-strong': ConnectionStrongIcon,
  'content-library': ContentLibraryIcon,
  controls: ControlsIcon,
  'credit-card': CreditCardIcon,
  credits: CreditsIcon,
  'cursor-click': CursorClickIcon,
  delete: DeleteIcon,
  desktop: DesktopIcon,
  'docs-dev': DocsDevIcon,
  'dots-horizontal': DotsHorizontalIcon,
  download: DownloadIcon,
  'edit-transcript': EditTranscriptIcon,
  'ellipses-vertical': EllipsesVerticalIcon,
  embed: EmbedIcon,
  envelope: EnvelopeIcon,
  'envelope-open': EnvelopeOpenIcon,
  error: ErrorIcon,
  expand: ExpandIcon,
  'expand-diagonal': ExpandDiagonalIcon,
  'expand-diagonal-window': ExpandDiagonalWindowIcon,
  'expand-horizontal': ExpandHorizontalIcon,
  'fast-forward': FastForwardIcon,
  favorite: FavoriteIcon,
  'favorite-outline': FavoriteOutlineIcon,
  featured: FeaturedIcon,
  'file-tree': FileTreeIcon,
  fill: FillIcon,
  'film-strip': FilmStripIcon,
  filter: FilterIcon,
  fit: FitIcon,
  fonts: FontsIcon,
  footer: FooterIcon,
  'full-screen': FullScreenIcon,
  gear: GearIcon,
  'getting-started': GettingStartedIcon,
  grid: GridIcon,
  'grip-dots-vertical': GripDotsVerticalIcon,
  header: HeaderIcon,
  'help-center': HelpCenterIcon,
  hide: HideIcon,
  home: HomeIcon,
  hourglass: HourglassIcon,
  import: ImportIcon,
  info: InfoIcon,
  integrations: IntegrationsIcon,
  keyboard: KeyboardIcon,
  layout: LayoutIcon,
  leave: LeaveIcon,
  'light-bulb': LightBulbIcon,
  link: LinkIcon,
  list: ListIcon,
  live: LiveIcon,
  localization: LocalizationIcon,
  lock: LockIcon,
  logout: LogoutIcon,
  maximize: MaximizeIcon,
  media: MediaIcon,
  megaphone: MegaphoneIcon,
  menu: MenuIcon,
  mic: MicIcon,
  'mic-off': MicOffIcon,
  minimize: MinimizeIcon,
  minus: MinusIcon,
  'minus-circle': MinusCircleIcon,
  mobile: MobileIcon,
  'more-options': MoreOptionsIcon,
  'move-left': MoveLeftIcon,
  'move-right': MoveRightIcon,
  music: MusicIcon,
  'my-library': MyLibraryIcon,
  'on-air': OnAirIcon,
  'open-new': OpenNewIcon,
  overview: OverviewIcon,
  page: PageIcon,
  'panel-left': PanelLeftIcon,
  'panel-right': PanelRightIcon,
  'panel-up': PanelUpIcon,
  'paper-clip': PaperClipIcon,
  password: PasswordIcon,
  pause: PauseIcon,
  pencil: PencilIcon,
  'pencil-sparkle': PencilSparkleIcon,
  people: PeopleIcon,
  pin: PinIcon,
  'pin-slash': PinSlashIcon,
  pip: PipIcon,
  play: PlayIcon,
  player: PlayerIcon,
  playlist: PlaylistIcon,
  plus: PlusIcon,
  podcast: PodcastIcon,
  preview: PreviewIcon,
  'private-chat': PrivateChatIcon,
  'private-user-sessions': PrivateUserSessionsIcon,
  project: ProjectIcon,
  'project-open': ProjectOpenIcon,
  properties: PropertiesIcon,
  'question-chat': QuestionChatIcon,
  'question-mark': QuestionMarkIcon,
  react: ReactIcon,
  record: RecordIcon,
  'record-group': RecordGroupIcon,
  redo: RedoIcon,
  refresh: RefreshIcon,
  remix: RemixIcon,
  replace: ReplaceIcon,
  reply: ReplyIcon,
  'request-video': RequestVideoIcon,
  'revert-to-original': RevertToOriginalIcon,
  rewind: RewindIcon,
  save: SaveIcon,
  'save-as-copy': SaveAsCopyIcon,
  scissors: ScissorsIcon,
  'screenshare-off': ScreenshareOffIcon,
  'screenshare-on': ScreenshareOnIcon,
  search: SearchIcon,
  send: SendIcon,
  shapes: ShapesIcon,
  share: ShareIcon,
  'sharing-permissions': SharingPermissionsIcon,
  simulcast: SimulcastIcon,
  sort: SortIcon,
  sparkle: SparkleIcon,
  speed: SpeedIcon,
  spinner: SpinnerIcon,
  stats: StatsIcon,
  'switch-accounts': SwitchAccountsIcon,
  tag: TagIcon,
  teleprompter: TeleprompterIcon,
  'text-bold': TextBoldIcon,
  'text-italics': TextItalicsIcon,
  'text-size': TextSizeIcon,
  thumbnail: ThumbnailIcon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  'timeline-vertical': TimelineVerticalIcon,
  token: TokenIcon,
  transcript: TranscriptIcon,
  transitions: TransitionsIcon,
  transparency: TransparencyIcon,
  trends: TrendsIcon,
  'trial-unlock-clock': TrialUnlockClockIcon,
  trim: TrimIcon,
  turnstile: TurnstileIcon,
  undo: UndoIcon,
  unlock: UnlockIcon,
  upload: UploadIcon,
  'users-permissions': UsersPermissionsIcon,
  'view-stream': ViewStreamIcon,
  volume: VolumeIcon,
  'volume-off': VolumeOffIcon,
  'volume-up': VolumeUpIcon,
  'volume-x': VolumeXIcon,
  wand: WandIcon,
  waveform: WaveformIcon,
  webhook: WebhookIcon,
  write: WriteIcon,
  'zoom-in': ZoomInIcon,
  'zoom-out': ZoomOutIcon,
};

export type IconNameType = keyof typeof iconMap;
